(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-section.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-section.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useContext
} = React;
const {
  products
} = svs.utils;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  ReactButton: Button
} = svs.ui;
const {
  CoOpContext,
  RetailerGameCard,
  RetailerGamePropType
} = svs.components.tipsen;
const {
  Carousel
} = svs.components.lbUi.carousel;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  usePrevious
} = svs.components.lbUtils.usePrevious;
const {
  getRetailUrl
} = svs.components.marketplace.helpers;
const {
  trackEvent
} = svs.components.analytics;
const RetailerSection = _ref => {
  let {
    branding,
    retailer
  } = _ref;
  const mobile = useMediaQuery(breakpoints.down(BREAKPOINT_AM)) ? 1 : false;
  const small = useMediaQuery(breakpoints.between(760, 1090)) ? 2 : false;
  const medium = useMediaQuery(breakpoints.between(1090, 1440)) ? 3 : false;
  const large = useMediaQuery(breakpoints.up(1440)) ? 4 : false;
  const itemsPerPage = mobile || small || medium || large;
  const lastPerPage = usePrevious(itemsPerPage);
  const {
    city,
    games,
    id,
    name
  } = retailer;
  const {
    active,
    setActive
  } = useContext(CoOpContext);
  const {
    productId
  } = useContext(DrawContext);
  const product = products.getProdName(productId);
  const sortedGames = games.sort((game1, game2) => {
    if (game2.currentUserNumberOfShares > game1.currentUserNumberOfShares) {
      return 1;
    }
    if (game2.currentUserNumberOfShares < game1.currentUserNumberOfShares) {
      return -1;
    }

    if (game2.buyStop < game1.buyStop) {
      return 1;
    }
    if (game2.buyStop > game1.buyStop) {
      return -1;
    }
    return 0;
  });
  const selectedIndex = sortedGames.findIndex(game => game.groupId === active.groupId && game.activatedDrawId === active.activatedDrawId);
  const retailerUrl = "".concat(svs.core.urlMapping.get('marketplace'), "/").concat(getRetailUrl(id, name), "?products=").concat(product, "&returnUrl=").concat(location.href);
  const spreadNavDueToHumongousAmountOfGames = itemsPerPage < 3 && games.length > 50;
  const settings = _objectSpread({
    align: mobile ? 'center' : 'start',
    gutter: 1,
    itemsPerPage: itemsPerPage || lastPerPage || 4,
    cardSize: 330,
    usePlaceholders: true
  }, selectedIndex !== -1 ? {
    selectedIndex
  } : {});
  return React.createElement("div", {
    className: "retailer-section"
  }, React.createElement("div", {
    className: "retailer-header"
  }, React.createElement("div", {
    className: "retailer-name notranslate"
  }, name), React.createElement("div", {
    className: "retailer-location"
  }, city), React.createElement("div", {
    className: "retailer-link"
  }, React.createElement(Button, {
    className: "retailer-goto-button",
    onClick: () => {
      trackEvent({
        category: 'Andelsspel produktsida',
        action: 'CTA andelsspel',
        opt_label: 'Till butiken'
      });
      window.location = retailerUrl;
    },
    size: 100,
    transparent: true
  }, "Till butiken"))), React.createElement("div", {
    className: "retailer-content"
  }, React.createElement(Carousel, {
    branding: branding,
    className: spreadNavDueToHumongousAmountOfGames ? 'carousel-nav-spread' : '',
    options: settings
  }, sortedGames.map(game => React.createElement(RetailerGameCard, {
    branding: branding,
    game: game,
    key: "".concat(game.activatedDrawId, "-").concat(game.containerId),
    onClick: (groupId, activatedDrawId) => setActive({
      groupId,
      activatedDrawId
    })
  })))));
};
RetailerSection.defaultProps = {
  branding: 'sport'
};
setGlobal('svs.components.tipsen.RetailerSection', RetailerSection);

 })(window);